import React, { Component } from 'react';
import { Container, Collapse, Button, Label, Form, FormGroup, Input, FormFeedback, Row, Col, Card, CardBody, CardLink, Modal, ModalHeader, ModalBody } from 'reactstrap'
import Fetch from '../../Auxiliares/fetch'
import ModConvo from '../../Paginas/Admin/modConvocatoria'
import modificarImg from '../../Img/modificar.png'
import eliminarImg from '../../Img/eliminar.png'
import TarjetaEtapa from '../../Componentes/Cards/etapasConvoCard'
import SideBar from '../../Img/SideBar.png'
import addImg from '../../Img/Plus.png'
import { toast } from 'react-toastify'
//import validaciones from '../../Auxiliares/validaciones'


export default class usuariosCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            nombre: '',
            inicio: '',
            termino: '',
            descripcion: '',
            documentosSolicitados: [" "],
            documentoCheck1: false,
            documentoCheck2: false,
            documentoCheck3: false,
            documentoCheck4: false,
            documentoCheck5: false,
            documentoCheck6: false,
            documentoCheck7: false,
            documentoCheck8: false,
            documentoTest: "",
            convocatoria: this.props.nombre,
            errors: {},
            poggers: false,
            isDelModalOpen: null,
            isModModalOpen: null,
            etapa: [
                { nombre: 'elgamer' }
            ]
        }
        this.toggleAdd = this.toggleAdd.bind(this)
        this.toggleDel = this.toggleDel.bind(this)
        this.toggleMod = this.toggleMod.bind(this)
        this.actualizarListaEtapa = this.actualizarListaEtapa.bind(this)
    }

    componentDidMount() {
        this.actualizarListaEtapa();
    }

    setValue(field, ev) {
        this.setState({ [field]: ev.target.value }, () => {
            let value;
            switch ([field].toString()) {
                /*case 'nombre':
                    if (validaciones.validar_nombre(this.state.nombre)) {
                        value = validaciones.validar_nombre(this.state.nombre)
                        this.setState(prevState => ({ errors: { ...prevState.errors, nombre: value } }));
                    } else {
                        this.setState({ errors: (delete Array.from(this.state.errors).nombre) });
                    }
                    break;

                case 'ap_paterno':
                    if (validaciones.validar_ap_paterno(this.state.ap_paterno)) {
                        value = validaciones.validar_ap_paterno(this.state.ap_paterno)
                        this.setState(prevState => ({ errors: { ...prevState.errors, ap_paterno: value } }));
                    } else {
                        this.setState({ errors: (delete Array.from(this.state.errors).ap_paterno) });
                    }
                    break;

                case 'ap_materno':
                    if (validaciones.validar_ap_materno(this.state.ap_materno)) {
                        value = validaciones.validar_ap_materno(this.state.ap_materno)
                        this.setState(prevState => ({ errors: { ...prevState.errors, ap_materno: value } }));
                    } else {
                        this.setState({ errors: (delete Array.from(this.state.errors).ap_materno) });
                    }
                    break;

                case 'rfc':
                    if (validaciones.validar_rfc(this.state.rfc)) {
                        value = validaciones.validar_rfc(this.state.rfc)
                        this.setState(prevState => ({ errors: { ...prevState.errors, rfc: value } }));
                    } else {
                        this.setState({ errors: (delete Array.from(this.state.errors).rfc) });
                    }
                    break;

                case 'rol':
                    if (validaciones.validar_rol(this.state.rol)) {
                        value = validaciones.validar_rol(this.state.rol)
                        this.setState(prevState => ({ errors: { ...prevState.errors, rol: value } }));
                    } else {
                        this.setState({ errors: (delete Array.from(this.state.errors).rol) });
                    }
                    break;*/

                default:
                    break;
            }
        })
    }

    actualizarListaEtapa() {
        //var data = new URLSearchParams(); 
        //data.append('convocatoria',this.props.nombre)

        Fetch('/getPeriodosConvocatoria', {
            method: 'POST',
            headers: { 'Content-Type': 'application/JSON' },
            body: JSON.stringify({ convocatoria: this.props.nombre })
            //body: data
        })
            .then(response => {
                this.setState({ etapa: response.data })
            })
            .catch(err => {
                switch (err.status) {
                    case 600:
                        console.log('Error inesperado')
                        break;

                    case 605:
                        console.log('Listado de elementos vacia')
                        this.setState({ etapa: [] })
                        break;

                    default:
                        break;
                }
            })
    }

    registrate = () => {
        const { convocatoria, nombre, inicio, termino, descripcion } = this.state

        let documentos = [];

        if (this.state.documentoCheck1) {
            documentos.push("solicitud")
        }
        if (this.state.documentoCheck2) {
            documentos.push("acta_nacimiento")
        }
        if (this.state.documentoCheck3) {
            documentos.push("acta_curp")
        }
        if (this.state.documentoCheck4) {
            documentos.push("documento_institucional")
        }
        if (this.state.documentoCheck5) {
            documentos.push("fotografia")
        }
        if (this.state.documentoCheck6) {
            documentos.push("forma_extranjero")
        }
        if (this.state.documentoCheck7) {
            documentos.push("contrato_estudiantil")
        }
        if (this.state.documentoCheck8) {
            documentos.push("nss")
        }

        let formData = new FormData();
        //if (validaciones.sinErrores(this.state.errors)) {
        Fetch('/addPeriodo', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ convocatoria, etapa: nombre, documentos, fecha_inicio: inicio, fecha_final: termino, descripcion: descripcion })
        }).then(Response => {
            this.actualizarListaEtapa();
            this.toggleAdd();
        }).catch(err => {
            switch (err.status) {

                case 600:
                    toast.error('Error inesperado')
                    break;

                case 601:
                    toast.error('Este usuario ya existe')
                    break;

                case 604:
                    toast.error('Este usuario no pudo ser registrado')
                    break;

                default:
                    break;
            }
        })
        //}
    }

    toggleDel(obj) {
        this.setState({
            isDelModalOpen: obj ? obj : null,
        })
    }

    toggleMod(obj) {
        this.setState({
            isModModalOpen: obj ? obj : null
        })
    }

    eliminar = (id) => {
        Fetch('/deleteInscripcion', {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id })
        })
            .then(response => {
                this.props.actualizar();
                this.toggleDel();
            })
            .catch(err => {
                switch (err.status) {
                    case 600:
                        console.log('Error inesperado')
                        break;

                    case 602:
                        console.log('Esta convocatoria no existe')
                        break;

                    default:
                        break;
                }
            })
    }

    toggleAdd() {
        this.setState(prevState => ({
            isAddModalOpen: !prevState.isAddModalOpen
        }));
        this.setState({
            number: '',
            inicio: '',
            termino: '',
            descripcion: '',
            documentoCheck1: false,
            documentoCheck2: false,
            documentoCheck3: false,
            documentoCheck4: false,
            documentoCheck5: false,
            errors: {},
        })
    }

    render() {
        return (
            <div className="col-12">
                <Card
                    className={this.props.encabezado ? "mb-1 col-12 py-2 bg-info text-white" : "list-group-item-lighter mb-1 col-12 py-2"}>                    <Row className="p-1 col-12 mx-1">
                        <Col type={!this.props.encabezado ? "button" : ''} onClick={() => this.setState((state) => ({ poggers: !state.poggers }))}
                            xs="4"><div className={this.props.encabezado ? "font-weight-bold text-center" : "text-left"}></div>{this.props.encabezado ? "Convocatoria" : this.props.nombre}</Col>
                        <Col type={!this.props.encabezado ? "button" : ''} onClick={() => this.setState((state) => ({ poggers: !state.poggers }))}
                            xs="4"><div className={this.props.encabezado ? "font-weight-bold text-center" : "text-left"}></div>{this.props.encabezado ? "Estado" : this.props.estado ? <div className="text-success d-inline">Activa</div> : <div className="text-danger d-inline">Inactiva</div>}</Col>
                        <Col
                            xs="2"><div className={this.props.encabezado ? "font-weight-bold text-center" : "text-left"}></div>{this.props.encabezado ? "Editar" : <img style={{ width: '25px', height: '25px' }} className="clicable" alt="modificar imagen" src={modificarImg} onClick={() => { this.toggleMod(this.props) }} />}</Col>
                        <Col
                            xs="2"><div className={this.props.encabezado ? "font-weight-bold text-center" : "text-left"}></div>{this.props.encabezado ? "Eliminar" : <img style={{ width: '25px', height: '25px' }} className="clicable" alt="eliminar imagen" src={eliminarImg} onClick={() => { this.toggleDel(this.props) }} />}</Col>
                    </Row>
                    {!this.props.encabezado &&
                        <Collapse isOpen={this.state.poggers}>
                            <TarjetaEtapa encabezado={true} />
                            {this.state.etapa.length > 0 ?
                                this.state.etapa.map((index) => (<TarjetaEtapa id={index._id} nombre={index.etapa} documentos={index.documentos} inicio={index.fecha_inicio} termino={index.fecha_final} descripcion={index.descripcion} convocatoria={this.props.nombre} actualizar={this.props.actualizar} actualizarEtapa={this.actualizarListaEtapa} />)) : <Col><Card className="d-flex p-5 text-center bg-secondary text-light shadow " style={{ border: 'dashed 2px' }} >Lista vacia</Card></Col>}
                            <Row className="p-1 col-12 mx-1">
                                <Col type="button" onClick={() => this.toggleAdd()}
                                    xs="12"><img style={{ width: '25px', height: '25px' }} className="clicable" alt="eliminar imagen" src={addImg} />
                                    <a className="font-weight-bold text-left ml-3">Añadir nuevo</a></Col>
                            </Row>
                            <hr className="my-1" />
                        </Collapse>}
                </Card>
                {this.props.encabezado && <Collapse isOpen={this.state.poggers}>
                    ¡Hola! Parece que has encontrado un mensaje secreto... ¡Ten un buen día! :)
                </Collapse>}



                <Modal isOpen={this.state.isDelModalOpen !== null} toggle={() => this.toggleDel()}
                    className="modal-md">
                    <ModalHeader toggle={() => this.toggleDel()}>Eliminar</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col>
                                <Card className="p-3 text-center">
                                    <Col>
                                        ¿Seguro que desea que la convocatoria
                                    <e className="font-weight-bold">
                                            {' ' + this.props.nombre + ' '}
                                        </e>sea eliminada?
                                    </Col>
                                    <CardBody>
                                        <CardLink><Button className="btn-danger" onClick={() => this.eliminar(this.state.isDelModalOpen.id)}>Aceptar</Button></CardLink>
                                        <CardLink><Button className="btn-light" onClick={() => this.toggleDel()}>Cancelar</Button></CardLink>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.isModModalOpen !== null} toggle={() => this.toggleMod()}
                    className="modal-md">
                    <ModalHeader toggle={() => this.toggleMod()}>Re-definir Convocatoria: {this.props.nombre}</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col>
                                <Card className="p-3 text-center">
                                    <div>
                                        <ModConvo id={this.props.id} nombre={this.props.nombre} estado={this.props.estado} cerrar={() => this.toggleMod()} actualizar={this.props.actualizar} />
                                    </div>
                                </Card>
                            </Col>

                        </Row>
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.isAddModalOpen} toggle={() => this.toggleAdd()}
                    className="modal-md">
                    <ModalHeader toggle={() => this.toggleAdd()}>Agregar Etapa para convocatoria {this.state.convocatoria}</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col>
                                <Card className="p-3 text-center">
                                    <Form className="register-form" method="post" encType="multipart/form-data" >

                                        <FormGroup >
                                            <Label> Nombre de la etapa</Label>
                                            <Input className="w-100" type="text" onChange={this.setValue.bind(this, "nombre")} placeholder="Procure un nombre corto" name="nombre" defaultValue={this.state.nombre} />
                                            <FormFeedback>{this.state.errors.nombre}</FormFeedback>
                                        </FormGroup>

                                        <FormGroup>
                                            <Label> Fecha de Incio de la etapa</Label>
                                            <Input className="w-100" type="date" onChange={this.setValue.bind(this, "inicio")} placeholder="" name="inicio" defaultValue={this.state.inicio} />
                                            <FormFeedback>{this.state.errors.inicio}</FormFeedback>
                                        </FormGroup>

                                        <FormGroup >
                                            <Label> Fecha de Término de la etapa</Label>
                                            <Input className="w-100" type="date" onChange={this.setValue.bind(this, "termino")} placeholder="Sólo número(s)" name="termino" defaultValue={this.state.termino} />
                                            <FormFeedback>{this.state.errors.termino}</FormFeedback>
                                        </FormGroup>

                                        <FormGroup>
                                            <Label> Descripción de la Convocatoria</Label>
                                            <Input className="w-100" type="text" onChange={this.setValue.bind(this, "descripcion")} placeholder="Con la mayor brevedad posible" name="descripcion" defaultValue={this.state.descripcion} />
                                            <FormFeedback>{this.state.errors.descripcion}</FormFeedback>
                                        </FormGroup>

                                        <Label>
                                            Documentos a solicitar esta etapa
                                        </Label>
                                        <Col className="xs-8">
                                            <hr className="my-1" />
                                            <Row>
                                                <Col xs="6" className="text-left"> Solicitud </Col>
                                                <Col xs="6" className="text-right">
                                                    <Button className={this.state.documentoCheck1 ? "xs-6 bg-danger ml-3 btn-block" : "xs-6 bg-success ml-3 btn-block"} onClick={() => this.setState((state) => ({ documentoCheck1: !state.documentoCheck1 }))}>
                                                        {this.state.documentoCheck1 ? "Seleccionado" : "No Seleccionado"}
                                                    </Button>
                                                </Col>
                                            </Row>
                                            <hr className="my-1" />
                                            <Row>
                                                <Col xs="6" className="text-left"> Acta de Nacimiento </Col>
                                                <Col xs="6" className="text-right">
                                                    <Button className={this.state.documentoCheck2 ? "xs-6 bg-danger ml-3 btn-block" : "xs-6 bg-success ml-3 btn-block"} onClick={() => this.setState((state) => ({ documentoCheck2: !state.documentoCheck2 }))}>
                                                        {this.state.documentoCheck2 ? "Seleccionado" : "No Seleccionado"}
                                                    </Button>
                                                </Col>
                                            </Row>
                                            <hr className="my-1" />
                                            <Row>
                                                <Col xs="6" className="text-left"> Acta de CURP </Col>
                                                <Col xs="6" className="text-right">
                                                    <Button className={this.state.documentoCheck3 ? "xs-6 bg-danger ml-3 btn-block" : "xs-6 bg-success ml-3 btn-block"} onClick={() => this.setState((state) => ({ documentoCheck3: !state.documentoCheck3 }))}>
                                                        {this.state.documentoCheck3 ? "Seleccionado" : "No Seleccionado"}
                                                    </Button>
                                                </Col>
                                            </Row>
                                            <hr className="my-1" />
                                            <Row>
                                                <Col xs="6" className="text-left"> Documento Institucional </Col>
                                                <Col xs="6" className="text-right">
                                                    <Button className={this.state.documentoCheck4 ? "xs-6 bg-danger ml-3 btn-block" : "xs-6 bg-success ml-3 btn-block"} onClick={() => this.setState((state) => ({ documentoCheck4: !state.documentoCheck4 }))}>
                                                        {this.state.documentoCheck4 ? "Seleccionado" : "No Seleccionado"}
                                                    </Button>
                                                </Col>
                                            </Row>
                                            <hr className="my-1" />
                                            <Row>
                                                <Col xs="6" className="text-left"> Fotografía </Col>
                                                <Col xs="6" className="text-right">
                                                    <Button className={this.state.documentoCheck5 ? "xs-6 bg-danger ml-3 btn-block" : "xs-6 bg-success ml-3 btn-block"} onClick={() => this.setState((state) => ({ documentoCheck5: !state.documentoCheck5 }))}>
                                                        {this.state.documentoCheck5 ? "Seleccionado" : "No Seleccionado"}
                                                    </Button>
                                                </Col>
                                            </Row>
                                            <hr className="my-1" />
                                            <Row>
                                                <Col xs="6" className="text-left"> Forma Extranjero </Col>
                                                <Col xs="6" className="text-right">
                                                    <Button className={this.state.documentoCheck6 ? "xs-6 bg-danger ml-3 btn-block" : "xs-6 bg-success ml-3 btn-block"} onClick={() => this.setState((state) => ({ documentoCheck6: !state.documentoCheck6 }))}>
                                                        {this.state.documentoCheck6 ? "Seleccionado" : "No Seleccionado"}
                                                    </Button>
                                                </Col>
                                            </Row>
                                            <hr className="my-1" />
                                            <Row>
                                                <Col xs="6" className="text-left"> Contrato Estudiantil </Col>
                                                <Col xs="6" className="text-right">
                                                    <Button className={this.state.documentoCheck7 ? "xs-6 bg-danger ml-3 btn-block" : "xs-6 bg-success ml-3 btn-block"} onClick={() => this.setState((state) => ({ documentoCheck7: !state.documentoCheck7 }))}>
                                                        {this.state.documentoCheck7 ? "Seleccionado" : "No Seleccionado"}
                                                    </Button>
                                                </Col>
                                            </Row>
                                            <hr className="my-1" />
                                            <Row>
                                                <Col xs="6" className="text-left"> NSS </Col>
                                                <Col xs="6" className="text-right">
                                                    <Button className={this.state.documentoCheck8 ? "xs-6 bg-danger ml-3 btn-block" : "xs-6 bg-success ml-3 btn-block"} onClick={() => this.setState((state) => ({ documentoCheck8: !state.documentoCheck8 }))}>
                                                        {this.state.documentoCheck8 ? "Seleccionado" : "No Seleccionado"}
                                                    </Button>
                                                </Col>
                                            </Row>
                                            <hr className="my-1" />
                                        </Col>
                                    </Form>

                                    <CardBody>
                                        <CardLink><Button className="btn-info" onClick={() => this.registrate()}>Crear</Button></CardLink>
                                        <CardLink><Button className="btn-light" onClick={() => this.toggleAdd()}>Cancelar</Button></CardLink>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </ModalBody>
                </Modal>
            </div>
        )
    }
}